<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="500px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t(`Edit Fixed Asset's Information`) }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end />
            </v-flex>

            <v-layout row wrap>
              <v-flex xs2 sm12 md12 class="py-1 px-2">
                <v-text-field
                  v-model="viewInfo.product_name"
                  :label="`${$t('Name')} *`"
                  name="fixed_product_name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('fixed_product_name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex pa-2>
                <v-autocomplete
                  v-model="viewInfo.product_type_id_fk"
                  :items="fullFixedAssetTypesList"
                  :label="`${$t('Type')}`"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('fixed_asset_type')"
                  data-vv-name="fixed_asset_type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs2 class="pt-2" v-if="hasPermissions(['asset_types_store'])">
                <v-tooltip top>
                  <v-btn label @click="$emit('add-fixed-asset-type')" slot="activator" icon fab small color="green">
                    <v-icon color="white" size="25">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new fixed asset type') }}</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs12 sm12 md12 class="pa-2">
                <v-textarea
                  v-model="viewInfo.product_description"
                  :label="$t('Description')"
                  box
                  name="product_description"
                  hide-details
                  height="80"
                  background-color="white"
                  :error="errors.has('product_description')"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'fixedAssets/getFixedAssetInfo',
      fullFixedAssetTypesList: 'fixedAssetTypes/getFullFixedAssetTypesList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateFixedAssetInfo: 'fixedAssets/updateFixedAssetInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('product_type_id_fk', this.viewInfo.product_type_id_fk || '')
            formData.append('product_name', this.viewInfo.product_name)

            let payload = { id: this.viewInfo.product_id, formData }
            this.updateFixedAssetInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
